import React, { PureComponent } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ListBookings from '../ListBookings';
import BookingPage from '../BookingPage';

class App extends PureComponent {
  render() {
    return (
      <Router basename="/bookings">
        <Switch>
          <Route exact path="/" component={ListBookings} />
          <Route exact path="/:bookingId" component={BookingPage} />
        </Switch>
      </Router>
    );
  }
}

export default App;
